import React from 'react';
import Box from '@mui/material/Box';

import Container from '../../components/outPages/Container';
import { Content, Footer, Headline } from './components';
import Main from '../../layouts/Main';

const Faq = () => {
  return (
    <Main>
      <Box>
        <Box
          sx={{
            backgroundColor: '#f7faff',
            backgroundImage: `linear-gradient(120deg, #ffffff 0%, #f7faff 100%)`,
            marginTop: -13,
            paddingTop: 13,
          }}
        >
          <Container>
            <Headline />
          </Container>
        </Box>
        <Container maxWidth={800}>
          <Content />
        </Container>
        <Box bgcolor="#ffffff">
          <Container>
            <Footer />
          </Container>
        </Box>
      </Box>
    </Main>
  );
};

export default Faq;
